import { useContent } from '../../../redux/reducer/content';
import { RARE, STANDARD } from '../../../constants/shared/lootboxes/types';
import { BOX, RARE_BOX } from '../../../constants/rewards';

export default function useGetLootboxType() {
  const { lootBoxes = {} } = useContent();

  return (id) => {
    for (const key in lootBoxes) {
      const lootBoxData = lootBoxes[key];
      if (!lootBoxData) continue;
      if (id === lootBoxData.id) return { [STANDARD]: BOX, [RARE]: RARE_BOX }[key];
    }
  };
}
